<!-- eslint-disable vue/attribute-hyphenation -->
<template>
  <div>
    <!-- Header Card -->
    <v-card class="ma-3 mb-3" elevation="5" variant="outlined">
      <v-row class="ma-0 d-flex justify-end">
        <v-col cols="5" class="align-self-center">
          <h3 class="text-h5 font-weight-bold">{{ title }}</h3>
        </v-col>
        <v-col cols="2" class="Form-Columns">
          <MultiSelect
            id="admin-depot-list"
            v-model="filters.depot"
            name="admin-depot-list"
            hide-details="auto"
            :items="allDepot"
            label=" Depot"
            item-text="depot_name"
            item-value="id"
            @change="handleModelValueUpdate"
          />
        </v-col>

        <v-col cols="2" class="Form-Columns">
          <MultiSelect
            id="control-tower-vehicle-type-filter"
            v-model="filters.vehicle_type"
            name="control-tower-vehicle-type-filter"
            :label="`Select ${labels.vehicleTypeLabel.name}`"
            :items="vehicleTypeList"
            item-text="title"
            item-value="id"
            :multiple="true"
            hide-details="auto"
            @input="handleModelValueUpdate"
          />
        </v-col>

        <!-- <v-col cols="2" class="Form-Columns">
                            <MultiSelect id="control-tower-ignition-filter" v-model="filters.ignition_status"
                                name="control-tower-ignition-filter" label="Ignition" :items="ignitionTypeChoices"
                                item-text="text" item-value="value" hide-details="auto"
                                @change="handleModelValueUpdate" />
                        </v-col> -->
        <v-col cols="2" class="Form-Columns">
          <MultiSelect
            id="admin-status-list"
            v-model="filters.status"
            name="admin-status-list"
            hide-details="auto"
            :items="statusChoices"
            label="Status"
            item-text="display_name"
            item-value="value"
            @change="handleModelValueUpdate"
          />
        </v-col>

        <v-col cols="1" class="Form-Columns">
          <v-row justify="end">
            <v-btn
              color="secondary"
              class="ml-2 mt-3 mr-4"
              height="37px"
              @click="resetFilters()"
            >
              Reset
            </v-btn>
          </v-row>
        </v-col>
        <!-- <v-col cols="8" class="text-right align-self-center">
          <v-row>
            
          </v-row>
        </v-col> -->
      </v-row>
    </v-card>

    <v-card class="ma-3" elevation="5" variant="outlined">
      <v-card-text class="pa-0">
        <v-row class="ma-0 d-flex align-center">
          <v-col cols="3" class="py-2">
            <v-tabs v-model="tab">
              <v-tab class="pa-0 font-weight-bold">Map View</v-tab>
              <v-tab class="pa-0 font-weight-bold">
                Trips &nbsp;
                <v-chip small color="primary">{{ totalItems }}</v-chip>
              </v-tab>
            </v-tabs>
          </v-col>

          <v-col cols="9" class="d-flex justify-end d-flex align-center py-0">
            <v-btn
              color="primary"
              class="mr-2"
              height="37px"
              @click="
                $router.push({ name: 'app-admin-asset-new-availability-list' })
              "
            >
              Vehicle Availability
            </v-btn>

            <v-btn
              color="success"
              class="mr-2"
              height="37px"
              @click="exportToExcel"
              :disabled="controlTowerData.length === 0"
            >
              Export Data
            </v-btn>

            <InputField
              id="list-search"
              v-model="searchValue"
              name="list-search"
              label="Search"
              class="Search-Field"
              bg-color="white"
              variant="outlined"
              dense
              append-icon="mdi-magnify"
              @click:clear="searchList()"
              hide-details="auto"
              v-on:keyup.enter="searchList"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-window v-model="tab">
      <v-window-item>
        <v-card class="ma-3 mt-0" elevation="5">
          <!-- <v-card-title class="font-weight-bold"> Map </v-card-title> -->
          <GoogleMap
            map-id="control-tower-gmap"
            mapWidth="100%"
            mapHeight="100%"
            :markers="markers"
            ref="controlTowerMap"
            class="Map-Height"
            :hasMapInfo="true"
          />
        </v-card>
      </v-window-item>

      <v-window-item>
        <v-card class="ma-3 mt-0" elevation="5">
          <v-card-text>
            <v-row class="ma-0">
              <v-col cols="12" class="px-3">
                <AgGridVue
                  style="width: 100%; height: calc(80vh - 165px)"
                  class="ag-theme-alpine"
                  id="myGrid"
                  :columnDefs="headers"
                  @grid-ready="onGridReady"
                  :defaultColDef="defaultColDef"
                  :grid-options="gridOptions"
                  :suppressDragLeaveHidesColumns="true"
                  :rowData="controlTowerData"
                  rowSelection="multiple"
                ></AgGridVue>
              </v-col>
              <v-col v-if="totalItems > 0" cols="12" class="">
                <Pagination
                  :pageNo="pageNo"
                  :totalItems="totalItems"
                  :pageSize="itemsPerPage"
                  @itemsPerPageChange="itemsPerPageChanged"
                  @prevPage="prevPage"
                  @nextPage="nextPage"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import InputField from "@/components/FormBaseComponents/InputField.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import GoogleMap from "@/components/General/GoogleMap.vue";
import Pagination from "@/components/General/Pagination.vue";
import * as XLSX from "xlsx";
import { statusChoice } from "@/utils/choices";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  name: "ControlTowerPage",
  components: {
    AgGridVue,
    InputField,
    MultiSelect,
    GoogleMap,
    Pagination,
  },
  data() {
    return {
      statusChoices: statusChoice,
      gridApi: null,
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      markers: [],
      gridColumnApi: null,
      tab: 0,
      searchValue: "",

      title: "Control Tower",
      headers: [
        {
          headerName: "Fleet No.",
          field: "fleet_number",
          sortable: false,
          minWidth: 170,
           pinned: "left",
          tooltipField: "fleet_number",
        },
        {
          headerName: "Trip ID",
          field: "trip_id",
          sortable: false,
          minWidth: 180,
          tooltipField: "trip_id",
        },
        {
          headerName: "Trip Status",
          field: "trip_status",
          sortable: false,
          minWidth: 160,
          cellRenderer: "StatusChip",
          cellRendererParams: (params) => {
            return {
              status: params.value,
            };
          },
        },
        {
          headerName: "Vehicle Status",
          field: "status",
          sortable: false,
          minWidth: 160,
          cellRenderer: "StatusChip",
          cellRendererParams: (params) => {
            return {
              status: params.value,
            };
          },
        },
        {
          headerName: "Gps ID",
          field: "gps_id",
          sortable: false,
          minWidth: 120,
        },
        {
          headerName: "Odometer Reading",
          field: "odometer_reading",
          sortable: false,
          minWidth: 120,
        },
        {
          headerName: "Depot",
          field: "depot",
          sortable: false,
          minWidth: 120,
        },
        {
          headerName: "Status Duration",
          field: "status_duration",
          sortable: false,
          minWidth: 160,
        },
        {
          headerName: "Source Location",
          field: "source_location",
          sortable: false,
          minWidth: 250,
          tooltipField: "source_location",
        },
        {
          headerName: "Mid Location",
          field: "mid_location",
          sortable: false,
          minWidth: 250,
          tooltipField: "mid_location",
        },
        {
          headerName: "Destination Location",
          field: "destination_location",
          sortable: false,
          minWidth: 250,
          tooltipField: "destination_location",
        },
        {
          headerName: "Driver Name",
          field: "driver_name",
          sortable: false,
          minWidth: 170,
          tooltipField: "driver_name",
        },
        
        // {
        //     headerName: "Vehicle No.",
        //     field: "vehicle_number",
        //     sortable: false,
        //     minWidth: 170,
        //     tooltipField: "vehicle_number",
        // },
        {
          headerName: "Vehicle Type",
          field: "vehicle_type",
          sortable: false,
          minWidth: 170,
          tooltipField: "vehicle_type",
        },
      ],
      controlTowerData: [],

      // Filters and options
      filters: {},

      allDepot: [],
      allTrailerTypeList: [],
      vehicleTypeList: [],
      ignitionTypeChoices: [
        { text: "On", value: "on" },
        { text: "Off", value: "off" },
      ],
      labels: {
        trailerTypeLabel: { name: "Trailer Type" },
        vehicleTypeLabel: { name: "Vehicle Type" },
      },

      // Grid configuration
      defaultColDef: {
        resizable: true,
        flex: 1,
        sortable: true,
        initialWidth: 200,
        wrapHeaderText: true,
        autoHeaderHeight: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
    };
  },
  computed: {
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },
  methods: {
    exportToExcel() {
      if (this.controlTowerData.length === 0) {
        this.$bus.$emit("showToastMessage", {
          message: "No data available to export",
          color: "warning",
        });
        return;
      }

      const exportData = this.controlTowerData.map((item) => ({
        "Trip ID": item.trip_id || "",
        Status: item.status || "",
        "Fleet Number": item.fleet_number || "",
        Depot: item.depot || "",

        "Source Location": item.source_location || "",
        "Mid Location": item.mid_location || "",
        "Destination Location": item.destination_location || "",
        "Driver Name": item.driver_name || "",
        "Vehicle No.": item.vehicle_number || "",
        "Vehicle Type": item.vehicle_type || "",
        "Gps ID": item.gps_id || "",
        "Status Duration": item.status_duration || "",
      }));

      const ws = XLSX.utils.json_to_sheet(exportData);

      ws["!cols"] = [
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Control Tower Data");

      const timestamp = new Date().toISOString().split("T")[0];
      const filename = `Control_Tower_Data_${timestamp}.xlsx`;

      XLSX.writeFile(wb, filename);

      this.$bus.$emit("showToastMessage", {
        message: "Data exported successfully",
        color: "success",
      });
    },

    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getControlTowerTripData();
    },
    prevPage() {
      this.pageNo--;
      this.getControlTowerTripData();
    },
    nextPage() {
      this.pageNo++;
      this.getControlTowerTripData();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      params.api.sizeColumnsToFit();
    },

    resetFilters() {
      this.filters = {};
      this.markers = [];
      this.controlTowerData = [];
      this.totalItems = 0;
      this.getControlTowerMapData();
      this.getControlTowerTripData();
    },

    getDepotList(params = {}) {
      params = {
        limit: "all",
      };
      this.$api.depot
        .getDepotList(params)
        .then((res) => {
          this.allDepot = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    getControlTowerMapData(params = {}) {
      this.$bus.$emit("showLoader", true);
      this.markers = [];

      const payload = {
        limit: "all",
        depot: this.filters.depot || null,
        vehicle_status: this.filters.status || null,
        vehicle_type: Array.isArray(this.filters.vehicle_type)
          ? this.filters.vehicle_type.join(",")
          : this.filters.vehicle_type || null,
        ...(params.search ? { search: params.search } : {}),
      };

      this.$api.controlTower
        .getControlTowerDashboardData(payload)
        .then(async (res) => {
          // this.controlTowerData = res.data;

          this.markers = [];
          res.data.forEach((trip) => {
            if (trip.map_data) {
              this.markers.push(trip.map_data);
            }
          });

          // this.totalItems = res.data.length;

          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't get the Data!",
            color: "error",
          });
        });
    },

    getControlTowerTripData(params = {}) {
      this.$bus.$emit("showLoader", true);
      // this.markers = [];

      const payload = {
        limit: "all",
        depot: this.filters.depot || null,
        vehicle_status: this.filters.status || null,
        vehicle_type: Array.isArray(this.filters.vehicle_type)
          ? this.filters.vehicle_type.join(",")
          : this.filters.vehicle_type || null,
        ...(params.search ? { search: params.search } : {}),
      };

      if (params.ordering && params.ordering.length > 0) {
        payload.ordering = params.ordering.join(",");
      }

      this.$api.trip
        .getControlTowerTripList(payload)
        .then(async (res) => {
          this.controlTowerData = res.data;

          this.totalItems = res.data.length;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't get the Data!",
            color: "error",
          });
        });
    },

    getAllVehicleTypeList() {
      this.$api.vehicleType
        .getVehicleTypeSelectList({ limit: "all" })
        .then((res) => {
          this.vehicleTypeList = res.data;
        })
        .catch((err) => {
          console(err);
        });
    },
    getTrailerTypeList() {
      this.$bus.$emit("showLoader", true);
      this.$api.trailerType
        .getTrailerTypeList({ limit: "all" })
        .then((res) => {
          this.allTrailerTypeList = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    resizeGrid() {
      if (this.gridApi) {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 100);
      }
    },

    handleModelValueUpdate() {
      this.getControlTowerMapData();
      this.getControlTowerTripData();
    },

    searchList() {
      this.getControlTowerMapData({ search: this.searchValue });
      this.getControlTowerTripData({ search: this.searchValue });
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("control_tower");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getAllVehicleTypeList();
        this.getTrailerTypeList();
        this.getDepotList();
        this.getControlTowerMapData();
        this.getControlTowerTripData();
      }
    }
  },
};
</script>

<style scoped>
.Default-Height {
  width: 100%;
  height: calc(66vh);
}

.custom-border-color {
  border-color: bg-lighten_4;
}

.centered-cell {
  display: flex;
  align-items: center;
  padding: 0px;
  height: 100%;
}

.Form-Columns {
  padding: 0 8px;
}

.Search-Field {
  max-width: 300px;
}

.row-failed {
  background-color: #ffebee !important;
}

.Map-Height {
  height: calc(105vh - 280px);
}
</style>
